import { Navigate, Outlet, useSearchParams } from "react-router";

import { PUBLIC_ROUTES } from "@/constants/routes";
import { useAppSelector } from "@/store/hooks";

/**
 * docs/ui/routes.md's Guest-only redirect rule: "Redirect to `/` (or to
 * `?redirect=<path>` if the login flow itself was reached via a redirect
 * chain — don't lose the original destination across an 'already logged
 * in' bounce)." A layout-route guard (renders `<Outlet />` or redirects,
 * wraps Login/Register/OTP as their common parent) rather than a
 * per-page check, so the redirect rule lives in exactly one place.
 */
export function RequireGuest() {
  const status = useAppSelector((state) => state.auth.status);
  const [searchParams] = useSearchParams();

  if (status === "authenticated") {
    const redirectTo = searchParams.get("redirect");
    return (
      <Navigate
        to={redirectTo && redirectTo.startsWith("/") ? redirectTo : PUBLIC_ROUTES.home}
        replace
      />
    );
  }

  return <Outlet />;
}
